import styled from "styled-components";

export const Wrap = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  strong {
    font-weight: 700;
    font-size: 27px;
    margin-bottom: -4px;
  }
  strike {
    opacity: 0.65;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: -4px;
    color: var(--color-danger);
    ::before {
      border-top-width: 3px !important;
      top: calc(50% - 2px);
    }
  }
  > span {
    font-size: 14px;
  }
`;
